<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <h2 class="fw-800 text-color10 ls-25 text-uppercase font-size-medium  mb-5" v-if="user"> {{ title ? title : $t('start_campaign')}} </h2>
    <div class="d-flex text-uppercase justify-content-center align-items-center mt-5 mb-10">
      <h1 class="mb-0 pt-1">{{ $t('start_your_campaign') }}</h1>
    </div>

    <template v-if="loader" class="text-center">
      <Loader
        :size="'big'"
      />
    </template>

    <template v-else>
      <!-- begin: new dashboards -->
      <template v-if="hasActiveCampaigns && 1 == 2">
        <div class="my-2 text-color2 font-size-small py-2 mb-5 col-lg-10 mx-auto">
          <h2 class="text-center">{{ $t('new_dashboards.welcome') }}</h2>
          <p>
            {{ $t('new_dashboards.description') }}
          </p>
          <p>
            {{ $t('new_dashboards.explore') }}
            <router-link :to="{ name: 'dashboards.index' }">{{ $t('click_here') }}</router-link>
          </p>
        </div>

        <template v-if="dashboardLoader" class="text-center">
          <Loader
            :size="'big'"
          />
        </template>
        <div v-else-if="user">
          <iframe
            v-if="user.dashboard_url"
            :src="metabaseDashboardUrl"
            height="2100"
            width="100%"
          ></iframe>
        </div>
      </template>
      <!-- begin: new dashboards -->

      <!-- begin: homepage content -->
      <template v-else>
        <!-- begin: summary campaigns -->
        <AiAgentCard
          v-if="user && user.company.enabled_features.ai_campaign_summary"
          :request="$t('summary_active_campaigns2')"
        />
        <!-- end: summary campaigns -->

        <CreateCampaign
          :title="title"
          :subTitle="$t('what_is_the_goal_of_your_campaign')"
          :user="user"
        ></CreateCampaign>
      </template>
    </template>
    <!-- end: homepage content -->
  </MainLayout>
</template>

<script>

import AiAgentCard from '@/components/chat/AiAgentCard'
import CampaignsService from '@/v1/modules/campaigns/services/campaigns-service'
import CreateCampaign from '@/components/campaigns/CreateCampaign.vue'
import MainLayout from '@/components/layouts/MainLayout'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

import Loader from '@/v1/components/common/Loader/Loader.vue'

import { mapState } from 'vuex'

export default {
  components: {
    AiAgentCard,
    CreateCampaign,
    Loader,
    MainLayout,
    Shortcuts
  },
  data () {
    return {
      dashboardLoader: true,
      loader: false,
      hasActiveCampaigns: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    title () {
      return `${this.$t('hello')}, ${this.user?.name}`
    },
    metabaseDashboardUrl () {
      return `${process.env.VUE_APP_METABASE_DASH_URL}/${this.user?.dashboard_url}#background=false&bordered=false&titled=false`
    }
  },
  metaInfo () {
    return {
      title: 'Home'
    }
  },
  mounted () {
    // this.getCampaigns()
    setTimeout(() => {
      this.dashboardLoader = false
    }, 5000)
  },
  methods: {
    /**
     * Get campaigns
     */
    async getCampaigns () {
      if (!this.user) return false
      try {
        const campaigns = await CampaignsService.getCampaigns({
          companyId: this.user?.company.id,
          status: ['ACTIVE']
        })

        if (campaigns.data.length > 0) {
          this.hasActiveCampaigns = true
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
  // watch: {
  //   user () {
  //     this.getCampaigns()
  //   }
  // }
}
</script>
